import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";
import { Reveal } from "@/components/Reveal";

export const SelectedWork = () => {
  const { t } = useLang();
  const { content, L } = useContent();
  const projects = (content?.projects || []).filter((p) => !p.demo);
  if (!projects.length) return null;
  return (
    <section className="bg-[#F7F3EC] py-20 lg:py-32" id="work" data-testid="selected-work-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="eyebrow-label mb-6">{t.work.eyebrow}</p>
          <h2 className="font-serif text-[#191713] text-3xl sm:text-4xl lg:text-5xl max-w-2xl">{t.work.title}</h2>
          <p className="mt-4 text-[#191713]/60 max-w-xl">{t.work.sub}</p>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-14 lg:gap-x-12">
          {projects.map((p, i) => (
            <Reveal key={p.id} delay={(i % 2) * 0.1}>
              <Link to={`/work/${p.id}`} className="group block" data-testid={`work-card-${p.id}`}>
                <div className="overflow-hidden bg-[#E9E0D0] border border-[#191713]/10">
                  <img src={p.image} alt={p.title} loading="lazy"
                    className="w-full h-auto block transition-transform duration-700 ease-out group-hover:scale-[1.02]" />
                </div>
                <div className="mt-5 flex items-start justify-between gap-4">
                  <div>
                    <h3 className="font-serif text-2xl text-[#191713] group-hover:text-[#A6853B] transition-colors">{p.title}</h3>
                    <p className="mt-1 text-xs tracking-[0.14em] uppercase text-[#A6853B]">{L(p.industry)}</p>
                    <p className="mt-3 text-sm text-[#191713]/65 leading-relaxed max-w-md">{L(p.description)}</p>
                    <p className="mt-2 text-xs text-[#8A8378]">{L(p.services_provided)}</p>
                  </div>
                  <ArrowUpRight size={20} className="text-[#A6853B] mt-1 shrink-0 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
